export default {
    sysPerf: {
        netmet: 'NetMet',
        systemPerformance: 'Rendimiento de Sistema',
        systemMetrics: 'Métrica',
        systemOverview: 'Visión General',
        streamer: 'Flámula',
        distributor: 'Distribuidora',
        ingestion: 'Ingestión',
        processing: 'Tratamiento',
        mongoDB: 'Base de Datos',
        ui: 'NetMet UI',
        kafka: 'Bus de Datos',
        rni: 'RNI',
        rniHosts: 'Anfitriones RNI',
        kbPerSec: 'kB/Seg',
        allCustomers: 'Todos los Clientes',
        customers: 'Clientes',
        msgsPerSecond: 'men/seg',
        writesPerSecond: 'escribe/seg',
        lag: 'retraso',
        sysdb: {
            topicRatesTitle: 'Tema I/O',
            topicRatesGraphLabel: 'Bytes/Seg',
            topicInputTitle: 'Entrada de Tema',
            topicInputGraphLabel: 'Bytes/Seg',
            topicOutputTitle: 'Salida de Tema',
            topicOutputGraphLabel: 'Bytes/Seg',
            topicLagTitle: 'Tema Max Retraso',
            topicLagGraphLabel: 'Contar',
            mongoTitle: 'I/O de Mongo',
            mongoGraphLabel: 'Bytes/Seg',
            systemDataRatesTitle: 'Flujo de Datos del Sistema',
            customerInputTitle: 'Entrada del Clientes',
            customerInputGraphLabel: 'Men/Seg',
            customerMsgsInPerSec: 'Entrada del Clientes',
            graphError: 'Error al recuperar los datos del gráfico para {graphName}',
            mongoRates: 'I/O de Mongo',
            mongoBytesInPerSec: 'Mongo Lecturas',
            mongoBytesOutPerSec: 'Mongo Escrituraes',
            infoTooltip: 'Las métricas de retardo en esta página son valores de instantáneas. Las otras métricas se derivan de 5 minutos de datos.'
        },
        status: {
            ok: 'Buen Rendimiento',
            warning: 'Advertencia de Rendimiento',
            alert: 'Alerta de Rendimiento'
        },
        topicMetrics: {
            readTopic: 'Leer Tema',
            writeTopic: 'Escribir Tema',
            kbPerSecond: 'kB/Seg',
            msgsPerSecond: 'Men/Seg',
            lag: 'Retraso'
        },
        serviceMetrics: {
            service: 'Servicio',
            requestsPerSecond: 'Reqs/Seg',
            secondsPerRequest: 'Segs/Req'
        },
        mongoMetrics: {
            readRate: 'Leer Aumento (kB/Seg)',
            writeRate: 'Tasa Aumento (kB/Seg)',
            upTime: 'Último Iniciado'
        },
        getSystemMetricsError: 'Error al recuperar las métricas del sistema',
        getSystemOverviewError: 'Error al recuperar las métricas de visión general del sistema',
        getSystemOverviewAllError: 'Error al recuperar las métricas de visión general del sistema',
        dateRange: {
            last24Hours: "Mostrando las últimas 24 horas de datos",
            last7Days: "Mostrando datos de los últimos 7 días",
            last30Days: "Mostrando datos de los últimos 30 días",
            custom: "Mostrando datos de {from} a {to}",
        },
        refreshRate: {
            'off': 'Apagada',
            '5m': '5 minutos',
            '10m': '10 minutos',
            '30m': '30 minutos',
            '1h': '1 hora',
            '5h': '5 horas',
            '24h': '24 horas',
        },
        graphanaDashError: "No se pudo cargar el panel de Graphana"
    }
}
